/* DGD Simple — theme behaviour. No dependencies. */
(function () {
  'use strict';

  var cfg = window.themeConfig || {};
  var routes = cfg.routes || {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents) {
    try {
      return new Intl.NumberFormat(cfg.locale || 'en', {
        style: 'currency',
        currency: cfg.currency || 'USD'
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------------------------------------------------------- Cart */

  var Cart = {
    drawer: null,
    lastFocus: null,

    init: function () {
      this.drawer = $('#cart-drawer');
      if (!this.drawer) return;

      $$('[data-cart-close]').forEach(function (el) {
        el.addEventListener('click', Cart.close.bind(Cart));
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && Cart.drawer.classList.contains('is-open')) Cart.close();
      });

      $$('[data-cart-open]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          Cart.refresh().then(Cart.open.bind(Cart));
        });
      });

      this.drawer.addEventListener('click', function (e) {
        var remove = e.target.closest('[data-line-remove]');
        if (remove) {
          e.preventDefault();
          Cart.change(remove.getAttribute('data-line-remove'), 0);
        }
      });
    },

    open: function () {
      this.lastFocus = document.activeElement;
      this.drawer.hidden = false;
      document.body.classList.add('drawer-open');
      // Force a reflow so the transition runs from its start state.
      void this.drawer.offsetWidth;
      this.drawer.classList.add('is-open');
      var close = $('.drawer__close', this.drawer);
      if (close) close.focus();
    },

    close: function () {
      var d = this.drawer;
      d.classList.remove('is-open');
      document.body.classList.remove('drawer-open');
      window.setTimeout(function () { d.hidden = true; }, 320);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },

    add: function (formData, button) {
      var label = button ? button.textContent : '';
      if (button) { button.disabled = true; button.textContent = 'Adding…'; }

      return fetch((routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'That item could not be added.');
          return Cart.refresh();
        })
        .then(function () {
          if (cfg.cartDrawer !== false) Cart.open();
        })
        .catch(function (err) {
          window.alert(err.message);
        })
        .then(function () {
          if (button) { button.disabled = false; button.textContent = label; }
        });
    },

    change: function (key, quantity) {
      return fetch((routes.cart_change_url || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          Cart.render(cart);
          if (document.body.classList.contains('template-cart')) window.location.reload();
        });
    },

    refresh: function () {
      return fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { Cart.render(cart); return cart; });
    },

    render: function (cart) {
      var count = $('[data-cart-count]');
      if (count) {
        count.textContent = cart.item_count;
        count.hidden = cart.item_count === 0;
      }

      var body = $('[data-cart-body]');
      var foot = $('[data-cart-foot]');
      if (!body || !foot) return;

      if (!cart.items.length) {
        body.innerHTML = '<p class="drawer__empty">' + escapeHtml(cfg.strings.cartEmpty) + '</p>';
        foot.hidden = true;
        return;
      }

      body.innerHTML = cart.items.map(function (item) {
        var img = item.image
          ? '<img src="' + escapeHtml(item.image) + '" alt="" width="72" height="72" loading="lazy">'
          : '';
        var variant = item.variant_title
          ? '<span class="cart-line__variant">' + escapeHtml(item.variant_title) + '</span>'
          : '';
        return '' +
          '<div class="cart-line">' +
            '<div class="cart-line__media">' + img + '</div>' +
            '<div>' +
              '<a class="cart-line__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
              variant +
              '<span class="cart-line__meta">Qty ' + item.quantity + '</span><br>' +
              '<button type="button" class="cart-line__remove" data-line-remove="' + escapeHtml(item.key) + '">' +
                escapeHtml(cfg.strings.remove) +
              '</button>' +
            '</div>' +
            '<span class="cart-line__price">' + money(item.final_line_price) + '</span>' +
          '</div>';
      }).join('');

      var subtotal = $('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = money(cart.total_price);
      foot.hidden = false;
    }
  };

  /* ------------------------------------------------------------ Product */

  function initProductForm(form) {
    var data = $('[data-variants]', form.closest('[data-product]') || document);
    var variants = data ? JSON.parse(data.textContent) : [];
    var idInput = $('[name="id"]', form);
    var button = $('[data-add]', form);
    var priceEl = $('[data-price]', form.closest('[data-product]') || document);
    var stockEl = $('[data-stock]', form.closest('[data-product]') || document);

    function currentVariant() {
      var chosen = $$('[data-option]', form).map(function (group) {
        var checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
      if (!chosen.length) return variants[0];
      return variants.find(function (v) {
        return chosen.every(function (value, i) { return v.options[i] === value; });
      });
    }

    function sync() {
      var v = currentVariant();

      if (!v) {
        button.disabled = true;
        button.textContent = cfg.strings.unavailable;
        return;
      }

      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.compare_at_price && v.compare_at_price > v.price
        ? '<span class="price price--sale">' + money(v.price) + ' <s class="price__was">' + money(v.compare_at_price) + '</s></span>'
        : '<span class="price">' + money(v.price) + '</span>';

      button.disabled = !v.available;
      button.textContent = v.available ? cfg.strings.addToCart : cfg.strings.soldOut;

      if (stockEl) {
        if (!v.available) {
          stockEl.textContent = cfg.strings.soldOut;
          stockEl.className = 'stock stock--out';
        } else {
          stockEl.textContent = '';
          stockEl.className = 'stock';
        }
      }

      if (v.featured_media) {
        var thumb = $('[data-thumb][data-media-id="' + v.featured_media.id + '"]');
        if (thumb) thumb.click();
      }

      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    $$('[data-option] input', form).forEach(function (input) {
      input.addEventListener('change', sync);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      Cart.add(new FormData(form), button);
    });

    sync();
  }

  function initGallery(root) {
    var main = $('[data-main-image]', root);
    if (!main) return;
    $$('[data-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.getAttribute('data-full');
        main.alt = thumb.getAttribute('data-alt') || '';
        $$('[data-thumb]', root).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------------------------------------------------------------- Misc */

  function initQty() {
    $$('[data-qty]').forEach(function (widget) {
      var input = $('input', widget);
      $$('button', widget).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-step') === 'up' ? 1 : -1;
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initHeader() {
    var toggle = $('[data-nav-toggle]');
    var drawer = $('[data-nav-drawer]');
    if (toggle && drawer) {
      toggle.addEventListener('click', function () {
        var open = drawer.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
      });
    }

    var searchToggle = $('[data-search-toggle]');
    var search = $('[data-search]');
    if (searchToggle && search) {
      searchToggle.addEventListener('click', function () {
        search.hidden = !search.hidden;
        searchToggle.setAttribute('aria-expanded', String(!search.hidden));
        if (!search.hidden) { var f = $('input', search); if (f) f.focus(); }
      });
    }
  }

  function initSort() {
    var sort = $('[data-sort]');
    if (!sort) return;
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    Cart.init();
    Cart.refresh();
    initHeader();
    initQty();
    initSort();
    $$('[data-product]').forEach(function (root) {
      initGallery(root);
      var form = $('[data-product-form]', root);
      if (form) initProductForm(form);
    });
  });
})();
